import React from 'react';
// @ts-ignore
import { useDrag } from 'react-dnd';
import { ExternalNews } from 'models/ExternalNews';

type Props = {
  externalNews: ExternalNews;
};

const ExternalNewsItem = ({ externalNews }: Props) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'ExternalNews',
    item: { id: externalNews.id },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  return (
    <div ref={drag}>
      <div>
        {!isDragging ? (
          <div className="d-flex justify-content-between align-items-center border-top p-4">
            <div className="mt-2 w-100 me-4">
              <small>Nome </small>
              <br />
              <b>{externalNews.name}</b>
            </div>
            <div className="mt-2 w-100 me-4">
              <small>Categoria </small>
              <br />
              <b className="text-truncate-wrap">{externalNews.category.name}</b>
            </div>
            <div className="mt-2 w-100 me-4">
              <small>Quantidade de Noticias </small>
              <br />
              <b className="text-truncate-wrap">{externalNews.quantityItems}</b>
            </div>
            <div className="mt-2 w-100 me-4">
              <small>Duração de cada noticia </small>
              <br />
              <b className="text-truncate-wrap">{externalNews.duration}s</b>
            </div>
          </div>
        ) : (
          <div className="campaign-medias-list-item">
            <div className="bg-dark-subtle"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExternalNewsItem;
